export function getYoutubeVideoId(url) {
    if (!url)
        return false;
    const regExp = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/;
    const match = url.match(regExp);
    return match && match[1].length === 11 ? match[1] : false;
}
//# sourceMappingURL=get-youtube-video-id.js.map